module.exports = __webpack_public_path__ + "static/media/FVJ.f4c576bc.pdf";